import { Button, Typography } from '@breetometer/components';
import { CryptoDestinationIcon } from 'BreetAssets';
import { ReceiveCurrencyBadge } from 'BreetComponents';
import { useModalApi } from 'BreetHooks';

const CryptoDestinationBanner = () => {
	const { handleOpenModal } = useModalApi();

	return (
		<Button
			className='cryptodestinationbanner border-dark-navy bg-primary-400'
			variant='native'
			onClick={handleOpenModal({ id: 'cryptoSettings' })}
		>
			<div className='cryptodestinationbanner_label bg-primary-500'>
				<CryptoDestinationIcon />
				<Typography
					as='span'
					variant='paragraph_2'
					className='color-primary-100'
				>
					Where should your crypto go?
				</Typography>
			</div>
			<ReceiveCurrencyBadge />
		</Button>
	);
};

export default CryptoDestinationBanner;
